// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:07:32+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            6cee10ce22bf873d19c678ce122a11e8
//    Signature:      eyJpdiI6Ilh4NFhQUXdpYkpEWWJ2Y2ZkWU94Rmc9PSIsInZhbHVlIjoiUlZibHV5WG5YOXdpS2dPc3o4Y0lLTk9Mb0NaUGpFNnF0R0VhcnNEZEM5UmdwZ1lrTjJwemk1R3FaUVM2M2x6VklwXC9HUE1DZ3BFNTJGcVwvUzNOMG9XdGttMTBGYkN5dm5ZVTZiUENoWE9Xd0U3UGlFOVJFUnk3cVk0MUNBTU1DR2IxZ3ZDdEthTEdaSGJ5bldxZXl5UVFGSmU2R0hubHgxZU1xUloxKzlcL3loWmhBOGVjOVNxdHZ4WWdaN1VwRlpVWEJUUm8yTk16R291clZlWEpGNXFyYUplNFd1cmZFblJPcUZEWHQ5bERQRzdwSm9YUEluNlA5WkVvSTJiazlnR2hvWkJCZEE5YUZMMkw0NWxLcXg0dUZGampYcSt0c1FaXC9jRDk5cjh2R3BcL2NGRHNGR3VuVThHWnRNVm1hZnBrN3dQNDlCNk9iY1BTRDZxa0JxS1Z1RnVvVFg4YlhZMGRzaGExeHV1Skc2UnVnbDVWWDRNS0VUdEhQcDk1Wm85a2dIS1FoMGhoeWFZbGJrUmdtdXptSXdnPT0iLCJtYWMiOiJiNTczOTE1MTRmMTRmM2Q3YjZiMDM4OGM2NDhkNjE1YmZmZTY0NjhhN2VmZWEzNjJlZDY2Yzc2ZDkyMjAzNmJjIn0=
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
